import { inject, InjectionToken } from '@angular/core';
import { LoadingService, ModalProviderPayload, ModalService } from '../services';
import { from, map, Observable, of, switchMap } from 'rxjs';
import { LoadingOptions, ModalOptions } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core';

export const MODAL_TOKEN: InjectionToken<ModalProvider> = new InjectionToken<ModalProvider>('MODAL_TOKEN', {
  factory: (): ModalProvider => {
    const modalService: ModalService = inject(ModalService);
    const loadingService: LoadingService = inject(LoadingService);

    return {
      showModal$<T>(opts: ModalOptions): Observable<T> {
        return from(modalService.showModal(opts)).pipe(
          switchMap((modal: HTMLIonModalElement) => modal.onDidDismiss()),
          map((modalResult: OverlayEventDetail<T | undefined>) => modalResult?.data as T)
        );
      },

      dismissAllStoredModals(): void {
        modalService.dismissAllStoredModals();
      },

      dismissModal$(data: ModalProviderPayload): Observable<ModalProviderPayload> {
        return from(modalService.dismissModal$(data));
      },

      isModalActive(): boolean {
        return modalService.isModalActive();
      },

      /** @deprecated Use LOADING_TOKEN instead */
      showLoading$(opts?: LoadingOptions): Observable<void> {
        return from(loadingService.showLoading(opts));
      },

      /** @deprecated Use LOADING_TOKEN instead */
      showLoading(opts?: LoadingOptions): void {
        loadingService.showLoading(opts);
      },

      /** @deprecated Use LOADING_TOKEN instead */
      dismissLoading$(): Observable<void> {
        loadingService.dismissLoading();
        return of(void 0);
      },

      /** @deprecated Use LOADING_TOKEN instead */
      dismissLoading(): void {
        loadingService.dismissLoading();
      },

      /** @deprecated Use LOADING_TOKEN instead */
      dismissAllLoadings$(): Observable<void> {
        return from(loadingService.dismissAllLoadings());
      },

      /** @deprecated Use LOADING_TOKEN instead */
      dismissAllLoadings(): void {
        loadingService.dismissAllLoadings();
      }
    };
  }
});

export interface ModalProvider {
  dismissAllStoredModals(): void;
  dismissModal$(data?: ModalProviderPayload): Observable<ModalProviderPayload>;
  showModal$<T>(opts: ModalOptions): Observable<T>;
  isModalActive(): boolean;

  /** @deprecated Use LOADING_TOKEN instead */
  showLoading$(opts?: LoadingOptions): Observable<void>;
  /** @deprecated Use LOADING_TOKEN instead */
  showLoading(opts?: LoadingOptions): void;
  /** @deprecated Use LOADING_TOKEN instead */
  dismissLoading$(): Observable<void>;
  /** @deprecated Use LOADING_TOKEN instead */
  dismissLoading(): void;
  /** @deprecated Use LOADING_TOKEN instead */
  dismissAllLoadings$(): Observable<void>;
  /** @deprecated Use LOADING_TOKEN instead */
  dismissAllLoadings(): void;
}
